
<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">

    <mat-sidenav-container autosize>
        <mat-sidenav #sidenav mode="over">
            <p>Sidenav für die gesamte webview</p>
        </mat-sidenav>

        <kkis-app-webshop-top-section1 [numberWarenkorbItems]="numberWarenkorbItems"></kkis-app-webshop-top-section1>
        <div *ngIf="showAdvertise">
            <kkis-app-webshop-advertise></kkis-app-webshop-advertise>
        </div>
        <kkis-app-webshop-info-section1 (numberWarenkorbItems)="getNumberWarenkorbItems($event)"></kkis-app-webshop-info-section1>
        <div *ngIf="showWarenkorb" style="margin-top: 60px;">
            <kkis-app-warenkorb-edit (numberWarenkorbItems)="getNumberWarenkorbItems($event)"></kkis-app-warenkorb-edit>
        </div>
        <div class="topofmainsection" *ngIf="!showWarenkorb">
            <kkis-app-webshop-main-section1 [search]="search" [category]="category" [minPreis]="minPreis" [maxPreis]="maxPreis" [filterGroessen]="groessen" [filterFarben]="farben" [filterMerkmale]="merkmale" [nurAufLager]="nurAufLager" (numberWarenkorbItems)="getNumberWarenkorbItems($event)"></kkis-app-webshop-main-section1>
        </div>
        <kkis-app-webshop-bottom-section1></kkis-app-webshop-bottom-section1>

    </mat-sidenav-container>

</div>